// The app has ONE settle physics: the spring the route transitions are integrated from
// (`TRANSITION_CONFIG.spring`, stiff and slightly under-damped). The route engine integrates it AHEAD of time
// and hands the trajectory to the compositor as Web Animations keyframes, where a long main-thread task — a
// React commit, an image decode — cannot starve it. Anything else in the app that has to travel gets the same
// treatment from here, so there is one physics and one mechanism rather than a CSS curve that resembles it.

// Relative, not aliased: this module is unit-tested, and the pure-node test runner resolves no `@/` alias.
import { SPRING_HZ, SPRING_TRAJECTORY } from '../components/custom/route-transition/core/spring'

/** The spring's trajectory from rest to rest, sampled evenly in time — which is why `easing: 'linear'` below.
 *  Re-exported (not re-integrated) so the sheet, the nav stack and the surface engine share ONE array. */
export { SPRING_TRAJECTORY }

/**
 * How long that trajectory takes. The sample count IS the duration (they're spaced at `SPRING_HZ`), so the
 * animation can't drift out of step with the curve it's running.
 */
export const SPRING_DURATION_MS = Math.round((SPRING_TRAJECTORY.length / SPRING_HZ) * 1000)

/**
 * Keyframe options for a spring travel. `linear` is not a curve choice — the samples ARE the curve, and any
 * easing on top would bend the physics. `fill: 'forwards'` holds the end value until the caller takes it back.
 */
export const SPRING_OPTIONS: KeyframeAnimationOptions = {
  duration: SPRING_DURATION_MS,
  easing: 'linear',
  fill: 'forwards',
}

/** The spring, in the caller's units: one value per keyframe, from `from` to `to`. */
export function springValues(from: number, to: number): number[] {
  return SPRING_TRAJECTORY.map((progress) => from + (to - from) * progress)
}
